export const compatibleVender = ["Google", "Samsung"];

export const compatibleModel = [
	"Pixel 3a",
	"G020A",
	"G020B",
	"G020C",
	"G020D",
	"G020F",
	"G020G",
	"G020H",
	"Pixel 4",
	"G020N",
	"G020I",
	"G020M",
	"Pixel 4 XL",
	"G020Q",
	"G0202J",
	"G020P",
	"Pixel 4a",
	"G025E",
	"G025H",
	"G025I",
	"G025J",
	"G025M",
	"G025N",
	"G6QU3",
	"Pixel 5",
	"GTT9Q",
	"GD1YQ",
	"G5NZ6",
	"SCV44",
	"SM-F9000",
	"SM-F900D",
	"SM-F900F",
	"SM-F900F",
	"SM-F900J",
	"SM-F900N",
	"SM-F900U",
	"SM-F900U1",
	"SM-F900W",
	"SM-F907B",
	"SM-F907N",
	"SM-F916U",
	"SM-F926U",
	"SM-W2020",
	"SM-W2021",
	"SCG03",
	"SM-G9880",
	"SM-G988B",
	"SM-G988B",
	"SM-G988N",
	"SM-G988Q",
	"SM-G988U",
	"SM-G988U1",
	"SM-G988W",
	"SM-N986C",
	"SCV47",
	"SM-F700",
	"SM-F7000",
	"SM-F700F",
	"SM-F700F",
	"SM-F700J",
	"SM-F700N",
	"SM-F700U",
	"SM-F700U1",
	"SM-F700W",
	"SM-F700W",
	"SM-F7070",
	"SM-F707B",
	"SM-F707N",
	"SM-F707U",
	"SM-F707U1",
	"SM-F707W",
	"SC-53A",
	"SCG04",
	"SCG06",
	"SGH-N219",
	"SGH-N323",
	"SM-N981U1",
	"SM-N986N",
	"SC-53A",
	"SCG04",
	"SCG06",
	"SGH-N219",
	"SGH-N323",
	"SCG05",
	"SM-F9160",
	"SM-F916B",
	"SM-F916N",
	"SM-F916Q",
	"SM-F916U1",
	"SM-F916W",
	"SM-G9910",
	"SM-G991B",
	"SM-G991B",
	"SM-G991N",
	"SM-G991Q",
	"SM-G991U",
	"SM-G991U1",
	"SM-G991W",
	"SM-G9960",
	"SM-G996B",
	"SM-G996B",
	"SM-G996N",
	"SM-G996U1",
	"SM-G996W",
	"SM-G9980",
	"SM-G998B",
	"SM-G998B",
	"SM-G998N",
	"SM-G998U",
	"SM-G998U1",
	"SM-G998W",
	"SM-F711B",
	"SM-F711N",
	"SM-F711U",
	"SM-F711U1",
	"SM-F711W",
	"SM-F9260",
	"SM-F926B",
	"SM-F926B",
	"SM-F926N",
	"SM-F926U1",
	"SM-F926W",
	"SM-G981B",
	"SM-G986B",
	"SM-N980F",
	"SM-N986B",
];
